import { render, staticRenderFns } from "./FooterBar.vue?vue&type=template&id=dbb86374&scoped=true&"
import script from "./FooterBar.vue?vue&type=script&lang=ts&"
export * from "./FooterBar.vue?vue&type=script&lang=ts&"
import style0 from "./FooterBar.vue?vue&type=style&index=0&id=dbb86374&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbb86374",
  null
  
)

export default component.exports